import { useEffect, useRef, useState } from 'react'
import Modal from '../ui/Modal'
import Textarea from '../ui/Textarea'
import Button from '../ui/Button'

export default function ImportDialog({ onCancel, onConfirm }) {
    const [text, setText] = useState('')
    const [creating, setCreating] = useState(false)
    const textRef = useRef(null)

    useEffect(() => {
        textRef.current?.focus()
    }, [])

    const lines = text.split(/\r?\n/).map((s) => s.trim()).filter(Boolean)

    const handleConfirm = async () => {
        setCreating(true)
        try {
            await onConfirm(lines)
        } finally {
            setCreating(false)
        }
    }

    return (
        <Modal open onClose={onCancel} title="Import lines → notes" maxWidth="max-w-2xl">
            <div className="p-4">
                <p className="text-sm text-zinc-500 mb-3">Paste lines below. One note per line.</p>
                <Textarea
                    ref={textRef}
                    value={text}
                    onChange={(e) => setText(e.target.value)}
                    placeholder={'First note title\nSecond note title\n.'}
                    className="w-full h-40 resize-none"
                />

                <div className="mt-3">
                    <p className="text-sm font-semibold text-black dark:text-white">
                        {lines.length === 0 ? 'Nothing to create yet.' : `Will create ${lines.length} note${lines.length === 1 ? '' : 's'}:`}
                    </p>
                    {lines.length > 0 && (
                        <ul className="mt-2 max-h-40 overflow-y-auto text-sm text-zinc-600 dark:text-zinc-400 list-disc list-inside space-y-0.5">
                            {lines.map((line, i) => (
                                <li key={i} className="truncate">{line.slice(0, 120)}</li>
                            ))}
                        </ul>
                    )}
                </div>

                <div className="mt-4 flex justify-end gap-2">
                    <Button variant="secondary" onClick={onCancel}>Cancel</Button>
                    <Button onClick={handleConfirm} disabled={lines.length === 0 || creating}>
                        {creating ? 'Creating' : `Create ${lines.length || ''} note${lines.length === 1 ? '' : 's'}`}
                    </Button>
                </div>
            </div>
        </Modal>
    )
}
